import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchUserAttributesThunk,
  clearUserAttributes,
} from "../../redux/slices/userSlice";
// Create a context for user-related data
export const UserContext = React.createContext();

export function UserProvider({ children }) {
  // Access the user attributes from the Redux store
  const userAttributes = useSelector((state) => state.user.userAttributes);

  // Initialize the Redux dispatch function
  const dispatch = useDispatch();

  // useEffect to fetch user attributes when the component mounts
  useEffect(() => {
    dispatch(fetchUserAttributesThunk()); // Dispatch the action to fetch user attributes
  }, [dispatch]); // Run the effect only once when the component mounts

  return (
    <UserContext.Provider
      value={{
        // Provide the user attributes from the Redux store
        userAttributes,

        // Provide a function to update user attributes by re-fetching them
        updateUserAttributes: () => dispatch(fetchUserAttributesThunk()),

        // Provide a function to clear user attributes from the Redux store
        clearUserAttributes: () => dispatch(clearUserAttributes()),
      }}
    >
      {children} {/* Render the children components within this provider */}
    </UserContext.Provider>
  );
}
